import * as React from "react";
import Navbar from "./Navbar";
import NavMenu from "./NavMenu";
import HamburgerMenu from "./HamburgerMenu";
import HamburgerMenuItem from "./HamburgerMenuItem";
import HelpMenu from "./HelpMenu";
import ProfileMenu from "./ProfileMenu";
import Sidebar from "./Sidebar";
import styled from "styled-components";
import { Divider } from "./DropdownMenu";
import DropdownMenuItem from "./DropdownMenuItem";
import DropdownMenuHeading from "./DropdownMenuHeading";
import SidebarLinkMenuItem from "./SidebarLinkMenuItem";
import SidebarContainerMenuItem from "./SidebarContainerMenuItem";
import * as ConcreteColors from "../../../ConcreteColors";

export type LayoutProps = {
  navbar: any;
  sidebar?: any;
  mainContent: any;
  footer?: any;
};

const SidebarAndMainContainer = styled("div")`
  display: flex;
  flex-direction: row;
`;

const StyledMain = styled.main`
  width: 100%;
`;

const BackgroundColorDiv = styled.div`
  background-color: ${ConcreteColors.gray200};
`;

export default class Layout extends React.Component<LayoutProps> {
  render() {
    return (
      <BackgroundColorDiv className="background-color-div">
        {this.props.navbar}
        <SidebarAndMainContainer id="sidebar-and-main-container">
          <div id="sidebar-container">{this.props.sidebar}</div>
          <StyledMain>
            {this.props.mainContent}
            {this.props.footer}
          </StyledMain>
        </SidebarAndMainContainer>
      </BackgroundColorDiv>
    );
  }

  static Navbar = Navbar;
  static DropdownMenuItem = DropdownMenuItem;
  static DropdownMenuHeading = DropdownMenuHeading;
  static DropdownDivider = Divider;
  static HamburgerMenu = HamburgerMenu;
  static HamburgerMenuItem = HamburgerMenuItem;
  static HelpMenu = HelpMenu;
  static ProfileMenu = ProfileMenu;
  static Sidebar = Sidebar;
  static SidebarLinkMenuItem = SidebarLinkMenuItem;
  static SidebarContainerMenuItem = SidebarContainerMenuItem;
  static NavMenu = NavMenu;
}
